export default function Alert() {
    return {
        MuiAlert: {
            styleOverrides: {
                standardInfo: {
                    backgroundColor: 'grey'
                }
            }
        }
    };
}
